import { I18N_DEFAULT_NAMESPACE } from '../constants';
import { useLocale } from './useLocale';
import { useI18N } from './useI18N';

export function useT() {
  const locale = useLocale();
  const i18n = useI18N();

  return i18n.getFixedT(locale, I18N_DEFAULT_NAMESPACE);
}
